module.exports = __webpack_public_path__ + "static/media/A4-Landscape-H1.9863816a.png";